import { useCallback, useEffect, useState } from 'react'
import { parseHoursToDeadline } from 'lib/helper'

const useHandleIndividualHoursToDeadline = (prevHoursToDeadline: number) => {
  const [hoursToDeadline, setHoursToDeadline] = useState<number>(0)

  useEffect(() => {
    setHoursToDeadline(prevHoursToDeadline)
  }, [prevHoursToDeadline])

  const handleHoursToDeadline = useCallback(
    (dateToDeadline: string, timeToDeadline: string) => {
      setHoursToDeadline(parseHoursToDeadline(dateToDeadline, timeToDeadline))
    },
    [setHoursToDeadline]
  )

  return {
    hoursToDeadline,
    handleHoursToDeadline,
  }
}

export default useHandleIndividualHoursToDeadline
